export const gatewayConstants = {
  GETALL_REQUEST: 'GATEWAY_GETALL_REQUEST',
  GETALL_SUCCESS: 'GATEWAY_GETALL_SUCCESS',
  GETALL_FAILURE: 'GATEWAY_GETALL_FAILURE',

  GET_REQUEST: 'GATEWAY_GET_REQUEST',
  GET_SUCCESS: 'GATEWAY_GET_SUCCESS',
  GET_FAILURE: 'GATEWAY_GET_FAILURE',

  ADD_REQUEST: 'GATEWAY_ADD_REQUEST',
  ADD_SUCCESS: 'GATEWAY_ADD_SUCCESS',
  ADD_FAILURE: 'GATEWAY_ADD_FAILURE',

  UPDATE_REQUEST: 'GATEWAY_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'GATEWAY_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'GATEWAY_UPDATE_FAILURE',
};
